import { forwardRef, memo } from 'react'

import { twMerge } from 'tailwind-merge'

import Link from './Link'

type Props = {
  text: string
  ariaLabel?: string
  className?: string
  onClick: (e: React.MouseEvent | React.KeyboardEvent) => void | Promise<void>
}

/** Button styled as a link, for inline use inside `Text.BodySmall` / `Text.Body`. Uses `Link` (button variant). */
const InlineTextLink = forwardRef<HTMLElement, Props>(
  ({ text, ariaLabel, className, onClick }, ref) => {
    return (
      <Link
        ref={ref}
        ariaLabel={ariaLabel}
        className={twMerge('align-baseline text-xs', className)}
        onClick={onClick}
      >
        {text}
      </Link>
    )
  }
)

export default memo(InlineTextLink)
